
import { computed, defineComponent, ref } from "vue";
import { useRoute } from 'vue-router';
import { getRouteItem, RoutesDataItem, vueRoutes } from '@/utils/routes';
import UserLayoutRoutes from './routes';
import SelectLang from '@/components/SelectLang/index.vue';
import useTitle from '@/composables/useTitle';
import {GlobalOutlined} from '@ant-design/icons-vue'
import 'animate.css';

export default defineComponent({
    name: 'UserLayout',
    components: {
        SelectLang,
        GlobalOutlined,
    },
    setup() {
        const route = useRoute();

        // 所有菜单路由
        const menuData = ref<RoutesDataItem[]>(vueRoutes(UserLayoutRoutes,'/user'));

        // 当前路由 item
        const routeItem = computed<RoutesDataItem>(()=>getRouteItem(route.path, menuData.value as RoutesDataItem[]));

        // 设置title
        useTitle(routeItem);

        console.log('routeItem',routeItem.value.path)

        return {
          routeItem
        }

    }
})
